import { OnlineQuoteEstimate } from "../../views/CustomerApp";

export default function route() {
  return [
    {
      path: accessRoute.ONLINE_QUOTE_ESTIMATE.path,
      private: true,
      name: accessRoute.ONLINE_QUOTE_ESTIMATE.name,
      key: accessRoute.ONLINE_QUOTE_ESTIMATE.key,
      belongsToSidebar: true,
      icon: accessRoute.ONLINE_QUOTE_ESTIMATE.icon,
      element: <OnlineQuoteEstimate />,
    },
  ];
}

export const accessRoute = {
  ONLINE_QUOTE_ESTIMATE: {
    path: '/customer/quote-estimate',
    name: 'Online Quote',
    key: 'quote_estimate',
    for: 'customer',
    icon: <em className="gg-quote-estimate"></em>,
  },
};

export const getChildrenRoutes = () => {
  return route();
};
